<!--
  Header markup mirrors https://re3.fccenvironment.co.uk. The jQuery slideToggle
  behaviour of the re3 theme (scripts.js) is reproduced with the menuOpen /
  searchOpen / openMenu state below.
-->
<header class="header" role="banner" [class.on-menu]="menuOpen" [class.on-search]="searchOpen">

  <div id="preHeader" style="height: 52px;">
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <!-- <a routerLink="https://re3.fccenvironment.co.uk/" class="bookSlot"><span>Book a slot<span class="deepLabel">&nbsp;for the Recycling Centre</span></span> <svg class="icon icon-calendar" aria-hidden="true"><use xlink:href="#icon-calendar"/></svg></a> -->
        </div>
      </div>
    </div>
  </div>

  <div id="header-top">
    <div class="container">
      <div class="row">
        <div id="logo-wrap" class="col-md-6">
          <span id="logo"><a href="https://re3.fccenvironment.co.uk" rel="nofollow" aria-label="re3 Home Page"><svg class="icon icon-re3_strap" aria-hidden="true"><use xlink:href="#icon-re3_strap"/></svg></a></span>
        </div>
        <div id="partner-logos" class="hidden-xs hidden-sm col-md-6">
          <a href="https://www.bracknell-forest.gov.uk/bins-and-recycling" class="h-bfc iconHeader" target="_blank" rel="noopener" aria-label="Bracknell Forest Council website"><svg class="icon icon-bracknell_bc" aria-hidden="true"><use xlink:href="#icon-bracknell_bc"/></svg></a>
          <a href="http://www.reading.gov.uk/recycling" class="h-rbc iconHeader" target="_blank" rel="noopener" aria-label="Reading Borough Council website"><svg class="icon icon-reading_bc" aria-hidden="true"><use xlink:href="#icon-reading_bc"/></svg></a>
          <a href="http://www.wokingham.gov.uk/rubbish-and-recycling/" class="h-wbc iconHeader" target="_blank" rel="noopener" aria-label="Wokingham Borough Council website"><svg class="icon icon-wokingham_bc" aria-hidden="true"><use xlink:href="#icon-wokingham_bc"/></svg></a>
          <a href="https://www.fccenvironment.co.uk" class="h-fcc iconHeader" target="_blank" rel="noopener" aria-label="FCC Environment website"><svg class="icon icon-fcc-logo" aria-hidden="true"><use xlink:href="#icon-fcc-logo"/></svg></a>
        </div>
        <div id="mobile-icons" class="visible-xs visible-sm">
          <button id="menu-toggle" type="button" [attr.aria-expanded]="menuOpen" aria-controls="menu-main-menu" (click)="toggleMenu()">Menu</button>
          <!-- <button id="search-toggle" type="button" [attr.aria-expanded]="searchOpen" aria-controls="search-container" aria-label="Search this site" (click)="toggleSearch()"><svg class="icon icon-magnifying-glass" aria-hidden="true"><use xlink:href="#icon-magnifying-glass"/></svg></button> -->
        </div>
      </div>
    </div>
  </div>

  <div id="header-middle">
    <div class="container">
      <div class="row">
        <div class="col-md-2 col-md-push-10">
          <!-- <div id="search-container" [class.is-open]="searchOpen">
            <form role="search" method="get" id="searchform" class="searchform" action="https://re3.fccenvironment.co.uk/">
              <div class="search-wrap">
                <label for="s" class="sr-only">Search for:</label>
                <input type="search" id="s" name="s" value="" placeholder="Search..." aria-label="Search Terms" /><button type="submit" id="searchsubmit" aria-label="Search now"><svg class="icon icon-magnifying-glass" aria-hidden="true"><use xlink:href="#icon-magnifying-glass"/></svg></button>
              </div>
            </form>
          </div> -->
        </div>
        <div class="col-md-10 col-md-pull-2">
          <nav role="navigation" aria-label="Main Navigation">
            <ul id="menu-main-menu" class="top-nav" [class.is-open]="menuOpen">
              <li *ngFor="let item of menu; let i = index"
                  class="menu-item"
                  [class.menu-item-has-children]="item.children?.length">
                <a [href]="item.url"
                   [attr.target]="item.children?.length ? null : '_blank'"
                   [attr.rel]="item.children?.length ? null : 'noopener'"
                   [class.active]="openMenu === i"
                   [attr.aria-expanded]="item.children?.length ? openMenu === i : null"
                   (click)="onMenuClick($event, i, item)">{{ item.label }}</a>
                <ul class="sub-menu" *ngIf="item.children?.length" [class.is-open]="openMenu === i">
                  <li class="menu-item" *ngFor="let child of item.children">
                    <a [href]="child.url" target="_blank" rel="noopener">{{ child.label }}</a>
                  </li>
                </ul>
              </li>
            </ul>
          </nav>

          <nav class="social-float" aria-label="re3 on social media">
            <ul id="social-float" [class.is-open]="menuOpen">
              <li><a href="https://www.facebook.com/re3recycling" title="re3 on Facebook" target="_blank" rel="noopener" class="social-link social-facebook"><svg class="icon icon-facebook" aria-hidden="true"><use xlink:href="#icon-facebook"/></svg></a></li>
              <li><a href="http://www.twitter.com/re3recycling" title="re3 on Twitter-X" target="_blank" rel="noopener" class="social-link social-twitter"><svg class="icon icon-twitter" aria-hidden="true"><use xlink:href="#icon-twitter"/></svg></a></li>
              <li><a href="https://www.instagram.com/re3recycling/" title="re3 Instagram" target="_blank" rel="noopener" class="social-link social-instagram"><svg class="icon icon-instagram-inv" aria-hidden="true"><use xlink:href="#icon-instagram-inv"/></svg></a></li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>

</header>
